import React, { useState } from 'react';
export function ContactCTASection() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  const inputClass = 'w-full px-4 py-3.5 border border-gray-200 bg-white text-black text-sm placeholder-gray-400 focus:outline-none focus:border-[#CC0000] transition-colors';
  return <section className="w-full bg-white" data-id="element-108">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-109">
        {/* LEFT — Full-bleed image */}
        <div className="relative overflow-hidden" style={{
        minHeight: '500px'
      }} data-id="element-110">
          <img src="https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?w=800&q=80" alt="Ameritech Tires service technician" className="absolute inset-0 w-full h-full object-cover" data-id="element-111" />
        </div>

        {/* RIGHT — Contact form */}
        <div className="flex flex-col justify-center p-12 sm:p-16" style={{
        background: '#F5F5F5'
      }} data-id="element-112">
          <p className="text-xs font-bold uppercase mb-3" style={{
          color: '#CC0000',
          letterSpacing: '0.2em'
        }} data-id="element-113">
            Get in Touch
          </p>
          <h2 className="font-black text-black text-2xl sm:text-3xl mb-2 leading-tight" data-id="element-114">
            Reach Out for Fast, Reliable Tire Solutions!
          </h2>
          <p className="text-sm mb-8" style={{
          color: '#616365'
        }} data-id="element-115">
            We will get back to you within 24 hours.
          </p>

          {submitted ? <div className="py-10 text-center" data-id="element-116">
              <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{
            background: 'rgba(130,36,51,0.10)'
          }} data-id="element-117">
                <span className="text-2xl" data-id="element-118">✅</span>
              </div>
              <p className="font-semibold text-green-600 text-base" data-id="element-119">
                Thank you! We will be in touch shortly.
              </p>
              <p className="text-sm mt-2" style={{
            color: '#616365'
          }} data-id="element-120">
                Our team typically responds within a few hours.
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-121">
              <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Your Name" required className={inputClass} data-id="element-122" />
              <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Your Email" required className={inputClass} data-id="element-123" />
              <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="Your Phone" className={inputClass} data-id="element-124" />
              <textarea name="message" value={form.message} onChange={handleChange} placeholder="How can we help you?" rows={4} required className={inputClass} style={{
            resize: 'none'
          }} data-id="element-125" />
              <button type="submit" className="w-full text-white font-black uppercase tracking-widest py-4 text-sm transition-colors duration-200 mt-2" style={{
            background: '#CC0000',
            letterSpacing: '0.15em'
          }} onMouseEnter={e => e.currentTarget.style.background = '#AA0000'} onMouseLeave={e => e.currentTarget.style.background = '#CC0000'} data-id="element-126">
                SEND MESSAGE
              </button>
            </form>}
        </div>
      </div>
    </section>;
}